import { useIsFetching } from "@tanstack/react-query";

import { getAssetUrlQueryKey } from "./assetQueryKeys.ts";

interface Options {
  assetId?: string;
}

export const useAssetIsResolving = ({ assetId }: Options = {}) => {
  const assetUrlQueryKey = getAssetUrlQueryKey(assetId);
  return Boolean(
    useIsFetching({
      queryKey: assetUrlQueryKey,
    }),
  );
};
